// const debug = process.env.NODE_ENV !== 'production';
// const prefix = !debug ? '/flowers' : ''; /* This is prefix for github.pages.io */

const prefix = "";

const ROUTES = {
  ROOT: `${prefix}`,
  WREATHS: `${prefix}/wreaths`,
  BASKETS: `${prefix}/baskets`,
  MOUNDS: `${prefix}/mounds`,
  COMPOSITIONS: `${prefix}/compositions`,
  CHURCH: `${prefix}/church`,
};

export default ROUTES;
